import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalRandomObstacle = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Random Obstacle"
      gamePath="/userDashboard/game/jump-run"
      icon="solar:bomb-bold"
      instructions={[
        "Patch your better eye.",
        "Press the Spacebar to jump over incoming random obstacles on the screen."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalRandomObstacle;
